import { useCallback } from 'react'
import { useMutation } from 'react-query'
import { toast } from 'react-toastify'
import { paymentTransactions, postGatewayPaymentChargeWallet } from 'services/wallet'
import posthog from 'posthog-js'
import { rememberPaymentFlow } from 'utilities/analytics/paymentFlow'
import useGatewayHandoff from 'utilities/hooks/useGatewayHandoff'

export default function useSetTransaction() {
    const { locked, isLocked, lock, hold, release } = useGatewayHandoff()
    const { isLoading, mutate } = useMutation({
        mutationFn: (payload: any) => {
            return postGatewayPaymentChargeWallet(payload)
        },
        onSuccess: (result, variables) => {
            //@ts-ignore
            localStorage.setItem(
                'toBePaidTransactions',
                JSON.stringify({
                    type: 'wallet-charge',
                    data: [],
                    //@ts-ignore
                    // pk: result?.pk,
                    //@ts-ignore
                    // gateway: '',
                })
            )
            posthog.capture('payment_gateway_redirect', {
                flow_type: 'wallet_topup',
                amount: (variables as any)?.amount,
                gateway: (variables as any)?.gateway?.uniqueCode,
            })
            rememberPaymentFlow({
                flow_type: 'wallet_topup',
                amount: (variables as any)?.amount ?? null,
                gateway: (variables as any)?.gateway?.uniqueCode ?? null,
            })
            // A top-up always goes through a bank — there is nothing to top the
            // wallet up FROM otherwise — so an absent link means the request did
            // not produce one. Say so instead of calling `replace(null)`, which
            // navigates to the string "null" and loses the payer.
            if (!result?.payment_link) {
                release()
                posthog.capture('wallet_topup_failed', {
                    reason: 'no_payment_link',
                })
                toast.error('مشکلی پیش آمده!')
                return
            }
            // The button stays down while the browser is on its way to the
            // bank — see `useGatewayHandoff`.
            hold()
            window.location.replace(result.payment_link)
            toast.success('در حال انتقال به صفحه کارت به کارت')
        },
        onError: (error: any) => {
            release()
            // Surface the backend's specific message. An amount over the
            // کارت‌به‌کارت ceiling comes back as {"error": "سقف واریز ..."} — the
            // one thing the payer can act on — and «مشکلی پیش آمده» told
            // them nothing. Fall back to the generic toast when the body has no
            // string message (serializer errors are an object, network errors
            // have no body at all).
            const backendMessage = error?.response?.data?.error
            posthog.capture('wallet_topup_failed', {
                error_message:
                    typeof backendMessage === 'string' ? backendMessage : null,
                status: error?.response?.status,
            })
            toast.error(
                typeof backendMessage === 'string' && backendMessage
                    ? backendMessage
                    : 'مشکلی پیش آمده!'
            )
        },
    })
    const pay = useCallback(
        (payload: any) => {
            // Refused by the ref, not by `isLoading`: a second tap in the same
            // tick lands before React has re-rendered `disabled`.
            if (isLocked()) return
            lock()
            mutate(payload)
        },
        [isLocked, lock, mutate]
    )
    return { mutate: pay, isLoading: isLoading || locked }
}
